import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { errorCountAPI } from 'src/app/services/apiRoutes';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(public http: HttpClient) {}

  public errorCountSource = new Subject<number>();
  errorCount$ = this.errorCountSource.asObservable();

  getErrorCount() {
    return this.http.get(errorCountAPI).subscribe((res: any) => this.errorCountSource.next(res.errorCount));
  }
}
